import { TK_API_PROJECTS } from '@/config';
import { resetBaseURL } from '@/lib/axios-v1';
import { error } from '@/utils/logger';

import { APIResponse, Presigned } from '../types';

/**
 * Generate a file by blob data
 * @param response backend returned blob
 * @param fileNameWithSuffix full file name
 */
export const saveAsFile = (response: Blob, fileNameWithSuffix: string) => {
  const url = window.URL.createObjectURL(response);
  const link = document.createElement('a');
  // same as: link.setAttribute('href', url);
  link.href = url;
  // same as: link.setAttribute('download', fileNameWithSuffix);
  link.download = fileNameWithSuffix;
  document.body.appendChild(link);
  link.click();
};

/**
 * Open remote pdf in new browser tab
 * @param fileURL full url for pdf file
 */
const openPDFwithNewTab = (fileURL: string) => {
  const link = document.createElement('a');
  link.href = fileURL;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
};

/**
 * For create a presigned URL:
 * Method: POST
 * URL: {{url}}projects/{{id_project}}/blueprints/{{id_blueprint}}/presigns
 * @param editCtx
 */
const fetchPDFDownloadURL = async (
  projectId: string,
  fileId: string,
): Promise<APIResponse> => {
  const { projectId: pId, fileId: bId } = { projectId, fileId };
  const url = `${TK_API_PROJECTS}/${pId}/blueprints/${bId}/presigns`;
  return resetBaseURL().post(url);
};

/**
 * request a pdf download url and open it
 *
 * @date 2025/10/23
 * @param projectId
 * @param fileId
 * @returns
 */
export const openRemotePDF = async (
  projectId: string,
  fileId: string,
): Promise<APIResponse | { data: any; message: string }> => {
  try {
    // step - 1: load url
    const presignedResp = await fetchPDFDownloadURL(projectId, fileId);
    // NOTE: its `201` not `200` to indicate success!
    if (presignedResp.code !== 201) {
      throw new Error(presignedResp.message);
    }
    const { presigned_url } = presignedResp.data as Presigned;
    // step - 2: open it
    openPDFwithNewTab(presigned_url);
    return { data: presigned_url, message: 'success' };
  } catch (err) {
    console.log(`======= exception captured on downloading process! ========`);
    console.error(err);
    const { message } = err as Error;
    return { data: undefined, message };
  }
};
